import Axios from "../../Config/API";
import {
    lstTelaVinculada,
    vincularGrupo,
} from "../../../Interfaces/Geral/Grupos/GruposTelasInterface";
import Service from "../../Service";

export async function VincularTelaGrupoService(requestBody: vincularGrupo[]) {
    return Service(
        Axios.post(`/home/Grupotela/vinculartelagrupo`, requestBody)
    );
}

export async function DesvincularTelaGrupoService(idTelaGrupo: number[]) {
    return Service(
        Axios.put(`/home/Grupotela/desvinculartelagrupo`, idTelaGrupo)
    );
}

export async function ListarTelasVinculadasPorGrupoService(idGrupo: number) {
    return Service(
        Axios.get<Array<lstTelaVinculada>>(
            `/home/Grupotela/listartelasvinculadasporgrupo?idGrupo=${idGrupo}`
        )
    );
}

export async function ListarTelasDesvinculadasPorGrupoService(idGrupo: number) {
    return Service(
        Axios.get<Array<lstTelaVinculada>>(
            `/home/Grupotela/listartelasdesvinculadasporgrupo?idGrupo=${idGrupo}`
        )
    );
}
